import { NgModule } from '@angular/core';
import { UnreadNotificationsComponent } from './unread-notifications/unread-notifications';
@NgModule({
	declarations: [UnreadNotificationsComponent],
	imports: [],
	exports: [UnreadNotificationsComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts